import React from 'react';
import { InputPlacement } from './types';
import { SelectorMode } from '../UserSelection/types';
var InputAreaContext = React.createContext({
    extraInput: null,
    despInput: null,
    leaveWordInput: null,
    strangerLeaveWordInput: null,
    overlayClassName: '',
    inputPlacement: InputPlacement.footer,
    newMode: SelectorMode.user,
    setNewMode: Function,
    strangerResult: [],
    setStrangerResult: Function,
});
export default InputAreaContext;
//# sourceMappingURL=context.js.map